import {
  FAILURE_FIELD_DATA,
  REQUEST_FIELD_DETAILS,
  RECEIVE_FIELD_DETAILS,
  RECEIVE_FIELD_FEATURES,
  RECEIVE_COUNTRY_FEATURES,
} from '../constants/actionTypes';

export function receiveCountryFeatures(countryFeatures) {
  return {
    type: RECEIVE_COUNTRY_FEATURES,
    countryFeatures,
  };
}

export function getFieldDetails(fieldId) {
  return {
    type: REQUEST_FIELD_DETAILS,
    fieldId,
  };
}

export function receiveFieldFeatures(fieldFeatures) {
  return {
    type: RECEIVE_FIELD_FEATURES,
    fieldFeatures,
  };
}

export function receiveFieldDetails(details) {
  return {
    type: RECEIVE_FIELD_DETAILS,
    details,
  };
}

export function failureFieldData(error) {
  return {
    type: FAILURE_FIELD_DATA,
    error,
  };
}
